// src/pages/DashboardPage.jsx

// ════════════════════════════════════════════════════════════════════════════

//  ACTUALIZACIÓN: Agrega la sección 'alerts' → StudentAlertsTab

//  El onSectionChange se pasa como prop para que las CTAs de alertas

//  puedan navegar a subscription, teacher_agenda, etc.

// ════════════════════════════════════════════════════════════════════════════



import React, { useState, useEffect, useCallback } from 'react';

import { useLocation } from 'react-router-dom';

import Header from '../components/Header';

import SettingsSection from '../components/dashboard/SettingsSection';

import DashboardView from '../components/dashboard/DashboardView';

import PreferencesSection from '../components/dashboard/PreferencesSection';

import DashboardHeader from '../components/dashboard/DashboardHeader';

import SubscriptionTab from '../components/dashboard/subscription/SubscriptionTab';

import TeacherAgendaTab from '../components/dashboard/teacher_agenda/TeacherAgendaTab';



// 🔔 NUEVO: Import del Centro de Alertas

import StudentAlertsTab from '../components/dashboard/alerts/StudentAlertsTab';
// Rob, 27-09-2026: «no tenemos una pestaña de mis exámenes para saber los
// resultados». El panel tenía una sección que crecía sin fin; esto es el
// historial agrupado por examen, con la respuesta a «¿estoy mejorando?».
import MisExamenesTab from '../components/dashboard/exams/MisExamenesTab';

import PantallaConRed from '../components/PantallaConRed';



import './DashboardPage.css';

import usePageTracker from "../hooks/usePageTracker.js";



const sectionsMap = {

    dashboard: { Component: DashboardView, name: 'Dashboard' },

    alerts: { Component: StudentAlertsTab, name: 'Centro de Alertas' }, // ← NUEVA SECCIÓN
    exams: { Component: MisExamenesTab, name: 'Mis Exámenes' },

    teacher_agenda: { Component: TeacherAgendaTab, name: 'Mi Teacher & Agenda' },

    subscription: { Component: SubscriptionTab, name: 'Mi Suscripción' },

    preferences: { Component: PreferencesSection, name: 'Mis Preferencias' },

    settings: { Component: SettingsSection, name: 'Configuración' },

};



function DashboardPage() {

    usePageTracker("dashboard", "Panel de Progreso", null, "idle");

    const location = useLocation();



    const [activeSection, setActiveSection] = useState('dashboard');

    const [summaryData, setSummaryData] = useState(null);



    // Sync URL parameter to activeSection

    useEffect(() => {

        const params = new URLSearchParams(location.search);

        const tab = params.get('tab') || params.get('section');

        if (tab && sectionsMap[tab]) {

            setActiveSection(tab);

        }

    }, [location.search]);



    const refreshSummaryData = useCallback(() => {

        const token = localStorage.getItem('token');

        fetch("/api/progress/summary", {

            headers: { 'Authorization': `Bearer ${token}` },

        })

            .then(res => res.ok ? res.json() : null)

            .then(data => setSummaryData(data))

            .catch(err => console.error("Error fetching summary for header:", err));

    }, []);



    useEffect(() => {

        refreshSummaryData();

    }, [refreshSummaryData]);



    const { Component: ActiveComponent, name: nombreActivo } =

        sectionsMap[activeSection] || sectionsMap.dashboard;



    // Props base que reciben todos los componentes

    const componentProps = {

        onProfileUpdate: refreshSummaryData,

        summaryData: summaryData,

        // 🔔 CLAVE: onSectionChange permite que las CTAs de alertas

        // naveguen a secciones correctas (subscription, teacher_agenda…)

        onSectionChange: setActiveSection,

    };



    return (

        <div>

            <Header />

            <div className="dp-container">

                <main className="dp-main-content">

                    <DashboardHeader

                        summaryData={summaryData}

                        activeSection={activeSection}

                        onSectionChange={setActiveSection}

                    />



                    <section className="dp-section active">

                        {/* La red va DENTRO del dashboard y FUERA de la sección:

                            si una parte se rompe, el alumno conserva la cabecera

                            y el menú, y lee qué pasó (19-09-2026). */}

                        <PantallaConRed seccion={activeSection} nombre={nombreActivo}>

                            <ActiveComponent key={activeSection} {...componentProps} />

                        </PantallaConRed>

                    </section>

                </main>

            </div>

        </div>

    );

}



export default DashboardPage;